import { render, staticRenderFns } from "./handled-table.vue?vue&type=template&id=15848426&scoped=true&"
import script from "./handled-table.vue?vue&type=script&lang=js&"
export * from "./handled-table.vue?vue&type=script&lang=js&"
import style0 from "./handled-table.vue?vue&type=style&index=0&id=15848426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15848426",
  null
  
)

export default component.exports